import {BaseFilterModel} from '../shared/base/base-filter.model';

export class ExpertFilterModel extends BaseFilterModel {
  email: string;
  id: number;
  firstName: string;
  lastName: string;
  source: string;
  hasFilttrAccount: boolean;
  contractSigned: boolean;
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/clause/expert-filter.model.ts